import * as React from 'react';
import styled from 'styled-components';

import Horizon from 'components/Horizon';
import Stack from 'components/Stack';
import Starfield from 'components/Starfield';

const Wrapper = styled(Stack)`
  padding-block-start: var(--sleuth-safe-area-inset-top, 0);
  position: relative;
`;

const Content = styled(Stack)`
  min-block-size: 28rem;
  position: relative;
  z-index: 1;

  & > *:not(div) {
    inline-size: min(50ch, 48rem);
    max-inline-size: calc(100% - 2rem);
    position: relative;
    text-align: center;
    text-wrap: balance;
  }
`;

export default function Hero({ children }) {
  return (
    <Wrapper align="stretch" gap="0.75rem">
      <Starfield variant="primary" />
      <Content
        className="hero-content"
        align="center"
        justify="center"
        gap="1.5rem"
      >
        {children}
      </Content>
      <Horizon />
    </Wrapper>
  );
}
